import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import SearchIcon from '@mui/icons-material/Search';
import Rating from '@mui/material/Rating';
import { useAuth } from "../../hooks/AuthProvider";
import { getHeaders } from '../../utils/apis';
import Collapse from '@mui/material/Collapse';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { useSpring, animated } from '@react-spring/web';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Tabs from '@mui/material/Tabs';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import * as Icon from 'react-bootstrap-icons';

import './FabricMan.css';
import { styled } from '@mui/material';


class Category {
    constructor(data, children) {
        this.category_id = data.category_id;
        this.id = data.category_id;
        this.label = data.name;

        this.name = data.name;
        this.remark = data.remark;
        this.category_type = data.category_type;
        this.category_parent = data.category_parent;
        this.owner = data.owner;
        this.state = data.state;
        this.pos = data.pos;
        this.children = children;
    }

    addChild(data) {
        this.children.push(new Category(data, []));
        this.children.sort((a, b) => a.pos - b.pos);
    }

    addChild(data, children) {
        this.children.push(new Category(data, children));
        this.children.sort((a, b) => a.pos - b.pos);
    }

    removeChild(category_id) {
        this.children = this.children.filter(e => e.category_id === category_id);
    }

    searchChildByID(category_id) {
        for (let i = 0; i < this.children.length; i++) {
            let child = this.children[i];
            if (child.category_id === category_id) {
                return child;
            } else {
                let cat = child.searchChildByID(category_id);
                // Chi khi tim thay moi tra ve, kh thi cho parent ke tiep
                if (cat) return cat;
            }
        };
        return null;
    }

    searchChildByName(name) {
        this.children.find(child => child.name === name);
    }
}

function TransitionComponent(props) {
    const style = useSpring({
        to: {
            opacity: props.in ? 1 : 0,
            transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
        },
    });

    return (
        <animated.div style={style}>
            <Collapse {...props} />
        </animated.div>
    );
}

export default function FabricMan(props) {

    const [treeCats, setTreeCats] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [activeFabric, setActiveFabric] = useState("");
    const [fabricsData, setFabricsData] = useState([]);
    const [viewFabric, setViewFabric] = useState([]);

    const [tailorShops, setTailorShops] = useState([]);

    const [tailorshop, setTailorShop] = useState({ tailorshop_id: "1", short_name: "YB" });


    const [categoryData, setCategoryData] = useState({});
    const selectRef = useRef();


    const navigate = useNavigate();


    const { register, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm();

    const auth = useAuth();
    if (!auth.user) {
        auth.logOut();
        // return;
    }



    const updateSearch = (str) => {
        if (str == null) {
            setViewFabric(fabricsData);
            return;
        }
        str = str.toUpperCase();
        let temp = [];
        fabricsData.forEach((e) => {
            if (e['fabric_code'].indexOf(str) >= 0) {
                temp.push(e);
            }
        });
        setViewFabric(temp);
    }

    const changeSearchText = (event) => {
        setSearchText(event.target.value);
        if (event.target.value === "") {
            setSearchText(null);

        }

        updateSearch(event.target.value);
    }

    const handleSearchBtn = (event) => {
        if (searchText == null || searchText === "") {
            setSearchText(null);
        }
        updateSearch(searchText);
    }

    const handleCategoryClick = (event, itemIds) => {
        event.stopPropagation();
        // console.log(JSON.stringify(itemIds));
        // console.log(treeCats);

        treeCats.forEach((cat) => {
            if (cat.category_id === itemIds) {
                reset(cat);

            } else {
                let child = cat.searchChildByID(itemIds);
                if (child) {
                    reset(child);

                }
            }

        });




        if (itemIds === 1) {
            setViewFabric(fabricsData);
        } else {
            let temp = [];
            fabricsData.forEach((e) => {
                if (e.category_id === itemIds) {
                    temp.push(e);

                }

            });
            //setTimeout(() => { 
            setViewFabric(temp);
            //}, 500)
            // console.debug('ViewFabric:', temp);
        }
    }

    const handleImgClick = (event) => {

        // setActiveFabric(event.target.id);
        // let temp = { ...orderData };
        // let fabric = viewFabric.find(obj => obj['fabric_code'] === event.target.id);
        // console.debug("DEBUG: fabric=", fabric)

        // if (temp['cur_order'] === null || temp['cur_order'] === undefined) {
        //     temp['cur_order'] = 0;
        //     temp['order_infos'] = [{ fabric_code: fabric.fabric_code, small_img: fabric.small_img, num_of_shirt: 1, notes: "" }];
        // } else {
        //     temp.order_infos[temp.cur_order] = { fabric_code: fabric.fabric_code, small_img: fabric.small_img, num_of_shirt: 1, notes: "" };
        // }

        // console.debug("DEBUG: orderdata=", temp)
        // //props.selectFabric(temp, true);
        // setOrderData(temp);
        // localStorage.setItem('orderData', JSON.stringify(temp));
        // navigate('/designshirt');

        //   console.log(event.target);
    }

    const getChildren = (rowData, parent_id) => {
        let children = [];
        if (rowData.length !== 0) {
            rowData.forEach(e => {
                if (e['category_parent'] === parent_id) {
                    let item = new Category(e, getChildren(rowData, e['category_id']));
                    // if (item.children.length == 0) {
                    //     delete item.children;
                    // }
                    children.push(item);
                }
            });
        }
        return (children);
    }

    useEffect(() => {
        if (!auth.user) {
            auth.logOut();
            return;
        }


        fetch("/api/tailorshops/", {
            method: "GET",
            headers: getHeaders(auth),
        })
            .then((response) => response.json())
            //.then((jsonData) => addId(jsonData, "client_id"))
            .then((rowData) => {
                if (rowData["result"]) { auth.logOut(); return; }
                //getOrderItems(rowData2);
                //console.log(rowData);
                rowData.push({ name: 'All', short_name: '*', tailorshop_id: 0 })
                setTailorShops(rowData);

                if (rowData.length >= 1) {
                    setTailorShop(rowData[0]);
                }

            })
            .catch((error) => console.log(error));

        fetch("/api/catbyid/FabricCat/all", {
            method: "GET",
            headers: getHeaders(auth),
            //body: JSON.stringify(data),
        })
            .then((response) => response.json())
            //.then((jsonData) => addId(jsonData, "client_id"))
            .then((rowData) => {
                if (rowData["result"]) { auth.logOut(); return; }
                //   console.log(rowData);
                var treeitems = [];

                if (rowData.length !== 0) {
                    rowData.forEach(e => {
                        if (e['category_parent'] === "0") {
                            treeitems.push(
                                new Category(e, getChildren(rowData, e['category_id'])));
                        }
                    });
                }

                setTreeCats(treeitems);

                // setTimeout(() => {
                //     // console.debug("TREEITEMS:", treeItems);
                //     setTreeItems(treeitems);
                // }, 500);

            })
            .catch((error) => console.log(error));



        //if (props.fabricsData.length > 0) return;
        fetch("/api/fabrics/" + auth.user['tailorshop_id'], {
            method: "GET",
            headers: getHeaders(auth),
            //body: JSON.stringify(data),
        })
            .then((response) => response.json())
            //.then((jsonData) => addId(jsonData, "client_id"))
            .then((rowData) => {
                if (rowData["result"]) { auth.logOut(); return; }
                // const rowData2 = addId(rowData, "client_id");
                setFabricsData(rowData);
                setViewFabric(rowData);
                //props.setFabricsData(rowData);
            })
            .catch((error) => console.log(error));
        //fetchData();
    }, []);



    const handleTailorShopSelect = (event) => {

        let ts = tailorShops.find((e) => e.tailorshop_id === event.target.value);

        if (ts) {
            console.log('TS:', ts);
            setTailorShop(ts);

            fetch("/api/CatIdByOwnerId/" + ts.tailorshop_id + "/FabricCat/" + 0, {
                method: "GET",
                headers: getHeaders(auth),
                //body: JSON.stringify(data),
            })
                .then((response) => response.json())
                //.then((jsonData) => addId(jsonData, "client_id"))
                .then((rowData) => {
                    if (rowData["result"]) { auth.logOut(); return; }
                    //   console.log(rowData);
                    var treeitems = [];
                    let parent_id = null;
                    let curParent = null;
                    if (rowData.length !== 0) {
                        rowData.forEach(e => {
                            if (e['category_parent'] === "0") {
                                treeitems.push(
                                    new Category(e, getChildren(rowData, e['category_id'])));
                            }
                        });
                    }

                    setTreeCats(treeitems);

                    // setTimeout(() => {
                    //     // console.debug("TREEITEMS:", treeItems);
                    //     setTreeItems(treeitems);
                    // }, 500);

                })
                .catch((error) => console.log(error));

        } else {

            fetch("/api/catbyid/FabricCat/all", {
                method: "GET",
                headers: getHeaders(auth),
                //body: JSON.stringify(data),
            })
                .then((response) => response.json())
                //.then((jsonData) => addId(jsonData, "client_id"))
                .then((rowData) => {
                    if (rowData["result"]) { auth.logOut(); return; }
                    //   console.log(rowData);
                    var treeitems = [];
                    let parent_id = null;
                    let curParent = null;
                    if (rowData.length !== 0) {
                        rowData.forEach(e => {
                            if (e['category_parent'] === "0") {
                                treeitems.push(
                                    new Category(e, getChildren(rowData, e['category_id'])));
                            }
                        });
                    }

                    setTreeCats(treeitems);

                    // setTimeout(() => {
                    //     // console.debug("TREEITEMS:", treeItems);
                    //     setTreeItems(treeitems);
                    // }, 500);

                })
                .catch((error) => console.log(error));
        }


    }

    const onSubmit = data => console.log(data);

    const catAddChild = (event) => {
        console.log(event);
        const catData = getValues();
        navigate('/addcategory', {
            state: { catData, tailorshopSelect: selectRef.current.value }
        });

    }

    const catDelete = (event) => {
        alert("Delete Cat");
    }

    return (
        <>

            <Box sx={{ width: '100%', marginTop: '35px' }}>
                <div className='container-md'>
                    <div className="mb-3 row p-0">

                        <label className="col-sm-2 col-form-label" htmlFor="tailorshop"> Tailor shop:</label>
                        <div className="col-sm-10 " style={{ flexFlow: "row", display: "flex" }}>
                            <select className="form-control" aria-label="Tailor shop" style={{ height: "55px", width: "450px" }} id="tailorshop"
                                onChange={handleTailorShopSelect} ref={selectRef}>
                                {/* <option value="0" id="0" defaultValue>All</option> */}

                                {tailorShops.map((shop) => {
                                    return (
                                        <option value={shop.tailorshop_id} key={shop.tailorshop_id}>{shop.tailorshop_id} - {shop.name} ({shop.short_name})</option>
                                    );
                                })}
                            </select>
                        </div>
                        <p />
                        <hr />
                    </div>

                    <div className='row'>
                        <div className='col-4'>
                            <strong>Categories</strong>
                            {treeCats.length > 0 &&
                                <RichTreeView
                                    aria-label="customized"
                                    defaultExpandedItems={['1']}
                                    sx={{ overflowX: 'hidden', minHeight: 270, flexGrow: 1, maxWidth: 300 }}
                                    slotProps={{ item: { slots: { groupTransition: TransitionComponent } } }}
                                    onSelectedItemsChange={handleCategoryClick}
                                    items={treeCats}
                                />
                            }

                        </div>
                        <div className='col-8'>
                            <strong>Detail</strong>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Container className="p-3 ">
                                    <Row style={{ width: "100%" }}>
                                        <Col >
                                            <div className="mb-3">
                                                <label>Category ID:</label>&nbsp;<br />
                                                <input type="text" placeholder="category_id" {...register("category_id", { required: true })} disabled={true} />
                                            </div>

                                            <div className="mb-3">
                                                <label>Category Name:</label>&nbsp;<br />
                                                <input type="text" placeholder="name" {...register("name", { required: true })} />
                                            </div>
                                            <div className="mb-3">
                                                <label>Description:</label>&nbsp;<br />
                                                <input type="text" placeholder="remark" {...register("remark", { required: true })} />
                                            </div>
                                            <div className="mb-3">
                                                <label>Category Type:</label>&nbsp;<br />
                                                <input type="text" placeholder="category_type" {...register("category_type", { required: true })} disabled={true} />
                                            </div>
                                        </Col>


                                        <Col >
                                            <div className="mb-3">
                                                <label>Parent ID:</label>&nbsp;<br />
                                                <input type="text" placeholder="category_parent" {...register("category_parent", {})} />
                                            </div>
                                            <div className="mb-3">
                                                <label>State:</label>&nbsp;<br />
                                                <input type="text" placeholder="state" {...register("state", { required: true })} />
                                            </div>

                                            <div className="mb-3">
                                                <label>Owner:</label>&nbsp;<br />
                                                <input type="text" placeholder="owner" {...register("owner", { required: true })} />
                                            </div>
                                            <div className="mb-3">
                                                <label>Position:</label>&nbsp;<br />
                                                <input type="text" placeholder="pos" {...register("pos", {})} />
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                                <button type="submit" className="btn btn-primary">Update</button>&nbsp;
                                <button type="button" className="btn btn-success" onClick={catAddChild}>Add Child</button>&nbsp;
                                <button type="button" className="btn btn-danger" onClick={catDelete}>Delete</button>
                            </form>


                        </div>
                        <hr />
                    </div>
                    <div className='row'>
                        <div className='col-2'>
                            <strong>Fabric Management</strong>
                            {treeCats.length > 0 &&
                                <RichTreeView
                                    aria-label="customized"
                                    defaultExpandedItems={['1']}
                                    sx={{ overflowX: 'hidden', minHeight: 270, flexGrow: 1, maxWidth: 300 }}
                                    slotProps={{ item: { slots: { groupTransition: TransitionComponent } } }}
                                    onSelectedItemsChange={handleCategoryClick}
                                    items={treeCats}
                                />
                            }

                        </div>
                        <div className='col-10'>
                            <div className="mb-3 row p-0">
                                <div className="d-flex justify-content-end p-2">

                                    <div className="col-sm-10 " style={{ flexFlow: "row", display: "flex" }}>
                                        <input type="text" className="form-control" id="searchText" value={searchText}
                                            placeholder="Enter fabric code" onChange={changeSearchText}
                                            style={{ width: "320px" }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter")
                                                    handleSearchBtn();
                                            }} /> &nbsp;&nbsp;
                                        <span><button type="button" className="btn btn-success" onClick={handleSearchBtn}><SearchIcon /></button></span>
                                    </div>

                                </div>
                                <div className="d-flex justify-content-center p-12">
                                    <p />
                                    {/* srcSet={`${item.small_img}?w=300&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.small_img}?w=300&fit=crop&auto=format`} */}

                                    <ImageList sx={{ width: "1024px", height: "800px" }} cols={6}>
                                        {viewFabric.map((item) => (
                                            <ImageListItem key={item.fabric_code}>
                                                <div className='img-container'  >
                                                    <img
                                                        srcSet={`${item.small_img}?auto=format&dpr=2 2x`}
                                                        src={`${item.small_img}?auto=format`}
                                                        alt={item.full_name}
                                                        id={item.fabric_code}
                                                        onClick={handleImgClick}
                                                        style={{ display: "blocks", borderRadius: "10%", boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.4)" }}
                                                        className='holder'
                                                    />
                                                    <div id={item.fabric_code} className="overlay" onClick={handleImgClick}>Click to select</div>
                                                </div>
                                                {(activeFabric == item.fabric_code) ? <ImageListItemBar
                                                    title={item.full_name}
                                                    // subtitle={<span>code: {item.code}</span>}
                                                    position="below"
                                                    sx={{
                                                        "& .MuiImageListItemBar-title": { color: "white", border: "1px solid blue", backgroundColor: "#1976d2" }, //styles for title
                                                    }} />
                                                    : <ImageListItemBar
                                                        title={item.full_name}
                                                        // subtitle={<span>code: {item.code}</span>}
                                                        position="below"
                                                        sx={{
                                                            "& .MuiImageListItemBar-title": { color: "black" }, //styles for title
                                                        }} />
                                                }

                                            </ImageListItem>
                                        ))}
                                    </ImageList>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </Box>
        </>
    );
}